(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/init.js');
"use strict";


svs.tt.logger = new svs.core.log.Logger('module:tt');
const root = document.getElementById('tt-root');
if (root) {
  ReactDOM.render(React.createElement(svs.tt.components.App, null), root);
}

 })(window);